export default (elmApp) => {
    // If there is the port defined, subscribe to it...
    if (elmApp.ports.drawGoogleCharts) {
        elmApp.ports.drawGoogleCharts.subscribe(googleChartDraw);
    } else {
        console.log("There is NO definition for PORT [drawGoogleCharts] in the APP.")
    }

    // Port callback function...
    function googleChartDraw(portDta) {
        let divTag = portDta ? document.getElementById(portDta.chart) : null;
        if (divTag && divTag !== undefined) {
            switch (portDta.chart) {
                case "chart_histogram":
                    drawComboChart(divTag, portDta.data);
                    break;
                case "chart_regions":
                    drawGeoChart(divTag);
                    break;
                case "chart_dealers":
                    drawPieChart(divTag, portDta.data);
                    break;
                default:
                    console.log("There is NOT a valid Div Tag ID to process out...");
                    break;
            }
        } else {
            console.log("There was an ERROR retrieving Div Tag Node for Drawing...");
        }
    }

    // Round Number Function...
    function roundNumber(num, dcmals) {
        return +(Math.round(num + "e+" + dcmals) + "e-" + dcmals);
    }

    // Average between 7 previous items...
    function averageBySeven(items, pos) {
        let avg = 0,
            idx = 7;
        while (idx !== 0) {
            avg += items[pos - idx][1];
            idx -= 1;
        }
        return roundNumber(avg / 7, 2);
    }

    // Items Data Map...
    function dataAverageMap(item, idx, items) {
        if (idx !== 0) {
            item[2] = (idx <= 7) ? 0 : averageBySeven(items, idx);
        }
        return item;
    }

    // Creates Child Div...
    function createChildDiv(containerNde, divNodeID, ndeStyle) {
        let divNde = null;
        if (containerNde && containerNde !== undefined) {
            divNde = document.createElement('div');
            divNde.id = divNodeID;
            divNde.style = ndeStyle;
            containerNde.appendChild(divNde);
        }
        return divNde;
    }

    // Google Chart Drawing Function...
    function drawChart(gChart, chartData, chartOptions) {
        gChart.draw(google.visualization.arrayToDataTable(chartData), chartOptions);
        console.log("Google Chart Drawed Successfully...");
        console.log(chartData);
    }

    // Combo Chart Drawing...
    function drawComboChart(divTag, dataValues) {
        setTimeout(() => {
            let data = [
                ['día', 'CHI-e Emitidos']
            ];
            dataValues.forEach(dta => { data.push([dta.fecha, dta.emitidos]); });

            // Promedio respecto a los siete días previos...
            // data = data.map(dataAverageMap);

            // Creating Combo Chart Object
            let options = {
                title: 'Cantidad de CHI-e Emitidos diariamente',
                vAxis: { title: 'Emitidos', format: '', titleTextStyle: { italic: false, bold: true } },
                hAxis: { title: 'Fecha', titleTextStyle: { italic: false, bold: true } },
                seriesType: 'bars',
                series: { 1: { type: 'line' } }
            };

            // Drawing Chart to DivTag...
            let chart = new google.visualization.ComboChart(divTag);
            console.log("Drawing Google Combo Chart...");
            drawChart(chart, data, options);
        }, 500);
    }

    // Geo Chart Drawing...
    function drawGeoChart(divTag) {
        setTimeout(() => {
            let chartData = [
                ['Comuna', 'Población'],
                ['Ñuñoa', 2761477],
                ['Providencia', 1324110],
                ['San Miguel', 959574],
                ['Concepción', 907563],
                ['Antofagasta', 655875],
                ['Puerto Montt', 607906],
                ['Santiago', 380181],
                ['Huechuraba', 371282],
                ['Las Condes', 67370],
                ['Coquimbo', 52192],
                ['Viña del Mar', 38262]
            ];

            // Bar Chart...
            let barChartDiv = createChildDiv(divTag, "barchart_div", "position:absolute;top:0px;z-index:10;width:650px;height:480px;");
            if (barChartDiv && barChartDiv !== undefined) {
                // Creating Chart Element...
                let options = {
                    title: 'Emisión de CHI-e por Comuna',
                    legend: 'none'
                };

                // let barChartData = chartData.map(item => { item.pop(); return item; });
                let gChart = new google.visualization.BarChart(barChartDiv);
                // gChart.draw(google.visualization.arrayToDataTable(chartData), options);
                console.log("Drawing Google Bar Chart...");
                drawChart(gChart, chartData, options);
            } else {
                console.log("There was impossible to create Bar Chart");
            }

            // Geo Chart...
            let chartDiv = createChildDiv(divTag, "geochart_div", "width:auto;height:520px;");
            if (chartDiv && chartDiv !== undefined) {
                // Creating Chart Element...
                let options = {
                    region: 'CL',
                    displayMode: 'markers',
                    colorAxis: { colors: ['green', 'blue'] }
                };

                let gChart = new google.visualization.GeoChart(chartDiv);
                console.log("Drawing Google Geo Chart...");
                drawChart(gChart, chartData, options);
            } else {
                console.log("There was impossible to create Geo Chart");
            }
        }, 500);
    }

    // Pie Chart Drawing...
    function drawPieChart(divTag, dataValues) {
        setTimeout(() => {
            let data = [
                ['CHI-e', 'Emitidos']
            ];
            dataValues.forEach(dta => { data.push([dta.item, dta.emitidos]) });

            // Pie Chart Options...
            let options = {
                // legend: 'none',
                is3D: true,
                // colors: ['red', 'blue', 'cyan', 'black', 'brown', 'green', 'yellow', 'white'],
                title: 'EMISIÓN DE CHI-E POR DISTRIBUIDOR'
            };

            // Drawing Pie Chart...
            let chart = new google.visualization.PieChart(divTag);
            console.log("Drawing Google Pie Chart...");
            drawChart(chart, data, options);
        }, 500);
    }
}